import Home from "../components/homepage/Home";

const HomePage = () => {
    return(
        <Home/>
    );

}

export default HomePage;